import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/utils/logger';

export interface UserRole {
  isSuperAdmin: boolean;
  companyId?: string;
}

export async function getCurrentUserRole(activeCompanyId?: string): Promise<UserRole> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return { isSuperAdmin: false };

    const { data: superAdminCheck } = await supabase.rpc('is_super_admin', { 
      _user_id: user.id 
    });

    if (superAdminCheck) {
      return { isSuperAdmin: true };
    }

    const companyId = activeCompanyId || await getUserDefaultCompanyId(user.id);

    return { 
      isSuperAdmin: false, 
      companyId: companyId 
    };
  } catch (error) {
    logger.error('Error checking user role:', error);
    return { isSuperAdmin: false };
  }
}

async function getUserDefaultCompanyId(userId: string): Promise<string | undefined> {
  try {
    const { data: companyId } = await supabase.rpc('get_user_company_id', {
      _user_id: userId
    });
    return companyId;
  } catch (error) {
    logger.error('Error getting user default company:', error);
    return undefined;
  }
}

export function applyCompanyFilter<T extends { eq: (col: string, val: string) => T }>(
  query: T,
  companyId: string
): T {
  return query.eq('company_id', companyId);
}
